import React from 'react'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import StepProgressBarUI from '../../../widgets/output/StepProgressBarUI'
import CopyToClipboardUI from '../../../widgets/output/CopyToClipboardUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import LoanCreateModalSF from './LoanCreateModalSF'

const AccountLoanListUI = ({ context, loanList, account,
  onCreateLoanClick, onCancelCreateLoan, createLoanMode,
  onRowClick, onRefreshClick, onCopyToClipboard, copyToClipboardText
}) =>
  <div className='su_loan_lst'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          onRefreshClick={onRefreshClick}
          onCreateLoanClick={onCreateLoanClick}
        />
      }
      right={<span />}
    />

    <div className='g_flex_h g_m_bottom_50'>
      <span>{loanList.length} loan{loanList.length == 1 ? '' : 's'} displayed</span>
    </div>

    <LRTableBodyUI>
      {
        loanList.map((loan, i) =>
          <LoanRowUI i={i} key={i} context={context} loan={loan} onRowClick={onRowClick}
            onCopyToClipboard={onCopyToClipboard}
            copyToClipboardText={copyToClipboardText}
          />
        )
      }
    </LRTableBodyUI>

    <LoanCreateModalSF context={context}
      onRefreshClick={onRefreshClick}
      createMode={createLoanMode} onCancelCreate={onCancelCreateLoan}
      account={account}
    />
  </div>

const LoanRowUI = ({ i, context, loan, onRowClick, onCopyToClipboard, copyToClipboardText }) =>
  <LRTableRowUI
    context={context} className='g_flex_top'
    left={
      <RowLeftUI i={i} context={context} loan={loan}
        onCopyToClipboard={onCopyToClipboard}
        copyToClipboardText={copyToClipboardText}
      />
    }
    right={<RowRightUI loan={loan} />}
    onClick={onRowClick}
    rowId={loan.loanId}
  />

const RowLeftUI = ({ i, context, loan, onCopyToClipboard, copyToClipboardText }) =>
  <div className='g_flex_h g_flex_top left2'>
    <span>
      <b>{i + 1}</b>
    </span>
    <div className='g_flex_v g_m_left_50'>
      <div>
        <b>{loan.accountName}</b>
        <span className='g_m_left_100'>{loan.loanName}</span>
        <span className='g_m_left_100'><i>{loan.loanTypeLabel}</i></span>
        {
          loan.loanSubType &&
          <span className='g_m_left_100'><i>{loan.loanSubType}</i></span>
        }
        <span className='g_m_left_100'><i>{loan.appFlavor}</i></span>
        <span className='g_m_left_100'><i>{loan.purpose}</i></span>
        <span className='g_m_left_100'><i>{loan.capex ? "capex" : ""}</i></span>
        {
          loan.fundSource &&
          <span className='g_m_left_100'><i>{loan.fundSource}</i></span>
        }
        <div className='g_flex_h g_muted g_flex_left'>
          <span className='g_m_right_100'>{loan.parentLRN ? loan.parentLRN + ' > ' + loan.loanRefNum : loan.loanRefNum}</span>
          <CopyToClipboardUI text={loan.loanId} onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText} />
        </div>
      </div>
      <div className='g_m_top_50'>
        <StepProgressBarUI
          values={['requested', 'term_sheet', 'sanctioned', 'disbursed', 'closed']}
          selected={loan.status}
        />
        <div className='g_m_top_50 g_muted g_flex_h g_flex_left'>
          Requested: {loan.loanRequest.dateF1}
          <span className='g_m_left_100'>{loan.assignedUserName}</span>
          <span className='g_m_left_100'>{loan.loanRequest.loanPurpose}</span>
          <span className='g_m_left_100 g_info2'><b>{loan.interestYearDays}</b></span>
        </div>
      </div>
    </div>
  </div>

const RowRightUI = ({ loan }) =>
  <div className='g_flex_v right g_text_right'>
    {
      loan.subStatus &&
      <div>
        <BadgeUI label={loan.subStatus} />
      </div>
    }
    {
      loan.status == 'requested' &&
      <div className='g_flex_v g_m_top_50'>
        <span>{loan.loanRequest.amountF2}</span>
        <span>{loan.loanRequest.tenureMonths} months</span>
        <span className='g_no_wrap'>{loan.loanRequest.dateF1}</span>
      </div>
    }
    {
      loan.status == 'term_sheet' &&
      <div className='g_flex_v g_m_top_50'>
        <span>{loan.termSheet.amountF2}</span>
        <span>{loan.termSheet.tenureMonths} months</span>
        <span>{loan.termSheet.interestRate}% p.a.</span>
        <span className='g_no_wrap'>{loan.termSheet.dateF1}</span>
      </div>
    }
    {
      loan.status == 'sanctioned' &&
      <div className='g_flex_v g_m_top_50'>
        <span>{loan.sanction.amountF2}</span>
        <span>{loan.sanction.tenureMonths} months</span>
        <span className='g_no_wrap'>{loan.sanction.dateF1}</span>
      </div>
    }
    {
      loan.status == 'disbursed' &&
      <div className='g_text_right g_m_top_50 g_flex_v'>
        <b>Disbursed</b>
        <span className='g_no_wrap'>{loan.disbursement.amountF2}</span>
        <span className='g_no_wrap'>{loan.termSheet.tenureMonths} months</span>
        {
          loan.termSheet.interestMonths &&
          <span className='g_no_wrap'>Interest only: <br />{loan.termSheet.interestMonths} months</span>
        }
        <span className='g_no_wrap'>{loan.termSheet.interestRate}% p.a.</span>
        <span className='g_no_wrap'>{loan.disbursement.dateF1}</span>
        {
          loan.loanType === 'inv_discount' && loan.closedDateF &&
          <span className='g_small g_info'>Closed: {loan.closedDateF}</span>
        }
      </div>
    }
    {/*
        loan.status == 'disbursed' && loan.disbursementList.length !== 0 &&
        <div className='g_text_right g_m_top_50'>
          <b>Disbursed</b>
          {
            loan.disbursementList.map((disbursement, i) =>
              <div className='g_flex_v' key={i}>
                <span className='g_no_wrap'>{disbursement.amountF2}</span>
                <span className='g_no_wrap'>{disbursement.dateF1}</span>
              </div>
            )
          }
        </div>
      */}
    {
      loan.status === 'closed' &&
      <div className='g_m_top_50 g_text_right'>
        {loan.closedDateF}
      </div>
    }
  </div>

const ActionLeftUI = ({ context, onRefreshClick, onCreateLoanClick }) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
    <IconButtonUI icon='icon-plus' onClick={onCreateLoanClick} label='Create Loan' />
    <span className='g_m_left_100 g_large'><b>Loans in Account</b></span>
  </div>

export default AccountLoanListUI
